import { appReleaseFormModel, featureFormModel } from './appReleaseFormModel';

const {
  formField: { version, application, features },
} = appReleaseFormModel;

export default {
  [version.name]: '',
  [application.name]: '',
  [features.name]: [
    {
      [featureFormModel.moduleName.name]: '',
      [featureFormModel.title.name]: '',
      [featureFormModel.description.name]: '',
    },
  ],
};
